import { Spinner, SpinnerSize, Stack, Text } from 'office-ui-fabric-react'
import React from 'react'
import {
  ExperimentOverviewQueryResponse,
  getExperimentOverviewQuery,
} from '../../Api/experiments'
import { DataValue, graphql } from 'react-apollo'
import { ExperimentOverviewTable } from './ExperimentOverviewTable'
import { ScreenHeader } from '../../Components/ScreenHeader'

function ExperimentOverviewScreen({
  data,
}: {
  data?: DataValue<ExperimentOverviewQueryResponse, {}>
}) {
  const isDataReady = data && !data.loading && !!data.experimentOverview
  const experimentOverview = data!.experimentOverview! || []
  return (
    <Stack
      horizontalAlign="start"
      verticalAlign="start"
      verticalFill
      style={{ width: '100%' }}
    >
      <ScreenHeader path={['Experimentation Overview']} buttons={[]} />
      <Stack
        className="experiments-screen"
        horizontalAlign="center"
        verticalAlign="start"
        horizontal
        wrap
        styles={{
          root: {
            width: '100%',
            overflow: 'auto',
          },
          inner: {
            padding: 60,
          },
        }}
      >
        {!isDataReady ? (
          <Stack
            horizontalAlign="center"
            verticalAlign="center"
            verticalFill
            style={{ width: '100%' }}
          >
            <Spinner
              size={SpinnerSize.large}
              labelPosition={'right'}
              label="Loading"
            />
          </Stack>
        ) : experimentOverview.length ? (
          <ExperimentOverviewTable
            experimentOverviewEntries={experimentOverview}
          />
        ) : (
          <Empty />
        )}
      </Stack>
    </Stack>
  )
}

function Empty() {
  return (
    <Stack
      horizontalAlign="center"
      verticalAlign="center"
      verticalFill
      style={{ width: '100%' }}
    >
      <Text
        variant="xLarge"
        style={{
          maxWidth: 600,
          padding: 20,
          textAlign: 'center',
        }}
      >
        There are no experiments configured yet.
      </Text>
    </Stack>
  )
}

const withGql = graphql<{}, ExperimentOverviewQueryResponse>(
  getExperimentOverviewQuery,
  {
    options: () => ({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    }),
  }
)
const ExperimentOverviewScreenWithGql = withGql(ExperimentOverviewScreen)

export { ExperimentOverviewScreenWithGql as ExperimentOverviewScreen }
